import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipReceivedValue = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    O valor recebido é calculado automaticamente a partir da soma: valor cobrado + juros e multas. Por esse motivo, não é possível editá-lo.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipReceivedValue;